import { ApiResponse } from "../apiResponse";

const AUTHORIZATION_TOKEN_KEY = "AuthorizationToken";
const AUTHORIZATION_CLIENT_KEY = "Client";
const AUTHORIZATION_UID_KEY = "UID";

// @description This method will get the authorization credentials from the local storage and return it.
// @return Object, that contains the token.
export function getAuthCredentials(): { [key: string]: any } {
  let authorizationToken: string | null = localStorage.getItem(
    AUTHORIZATION_TOKEN_KEY
  );
  let client: string | null = localStorage.getItem(AUTHORIZATION_CLIENT_KEY);
  let uid: string | null = localStorage.getItem(AUTHORIZATION_UID_KEY);

  return {
    Authorization: authorizationToken,
    client,
    uid,
  };
}

// @description This method will sanitize the authorization credentials and return it.
//              The sanitization process will do the following:
//                1) Remove any empty or null values from the object
// @return Object, that contains the sanitized authorization credentials.
export function sanitizeAuthCredentials(credentials: { [key: string]: any }): {
  [key: string]: any;
} {
  let sanitizedAuthCredentials: { [key: string]: any } = {};
  Object.keys(credentials).forEach((key: string) => {
    if (!!credentials[key]) {
      sanitizedAuthCredentials[key] = credentials[key];
    }
  });
  return sanitizedAuthCredentials;
}

// @description This method will set the authorization credentials in the local storage.
export function setAuthCredentials(
  token: string,
  client: string,
  uid: string
): void {
  localStorage.setItem(AUTHORIZATION_TOKEN_KEY, token);
  localStorage.setItem(AUTHORIZATION_CLIENT_KEY, client);
  localStorage.setItem(AUTHORIZATION_UID_KEY, uid);
}

// @description This method will clear the authorization credentials from the local storage.
export function clearAuthCredentials(): void {
  localStorage.removeItem(AUTHORIZATION_TOKEN_KEY);
  localStorage.removeItem(AUTHORIZATION_CLIENT_KEY);
  localStorage.removeItem(AUTHORIZATION_UID_KEY);
}

// @description This method will set the authorization credentials in the local storage from an ApiResponse headers.
export function setAuthCredentialsFromApiResponse(response: ApiResponse): void {
  setAuthCredentials(
    response.headers.authorization.toString(),
    response.headers.client.toString(),
    response.headers.uid.toString()
  );
}
